<template>
  <div class="text-field">
    <label class="field-label">
      生年月日
      <span class="u-color-danger"> *</span>
    </label>
    <PublishBadge style="font-size: 10px; display: block; float: right;" />
    <div class="form-row" style="margin-top: 5px;">
      <ValidationProvider class="u-prs form-col" name="年" rules="required" v-slot="{ errors }">
        <div class="dropdown-select">
          <select v-model="selectedYear" @click="yearSelectFocused = true" @change="onYearChange" @blur="onYearBlur" :style="selectedYear === null ? 'color: #CAC9C9;' : ''">
            <option :value="null" disabled selected v-if="selectedYear === null && !yearSelectFocused">1990年</option>
            <option :value="null" disabled selected v-else>選択してください</option>
            <template v-for="option in years">
              <option :value="option.value">{{ option.name }}</option>
            </template>
          </select>
        </div>
        <div class="error-message">
          {{ errors[0] }}
        </div>
      </ValidationProvider>
      <ValidationProvider class="u-prs form-col" name="月" rules="required" v-slot="{ errors }">
        <div class="dropdown-select">
          <select v-model="selectedMonth" @click="monthSelectFocused = true" @change="onMonthChange" @blur="onMonthBlur" :style="selectedMonth === null ? 'color: #CAC9C9;' : ''">
            <option :value="null" disabled selected v-if="selectedMonth === null && !monthSelectFocused">1月</option>
            <option :value="null" disabled selected v-else>選択してください</option>
            <template v-for="option in months">
              <option :value="option.value">{{ option.name }}</option>
            </template>
          </select>
          <div class="error-message">
            {{ errors[0] }}
          </div>
        </div>
      </ValidationProvider>
      <ValidationProvider class="form-col" name="日" rules="required" v-slot="{ errors }">
        <div class="dropdown-select">
          <select v-model="selectedDate" @click="dateSelectFocused = true" @change="onDateChange" @blur="onDateBlur" :style="selectedDate === null ? 'color: #CAC9C9;' : ''">
            <option :value="null" disabled selected v-if="selectedDate === null && !dateSelectFocused">1日</option>
            <option :value="null" disabled selected v-else>選択してください</option>
            <template v-for="option in dates">
              <option :value="option.value">{{ option.name }}</option>
            </template>
          </select>
          <div class="error-message">
            {{ errors[0] }}
          </div>
        </div>
      </ValidationProvider>
    </div>
  </div>
</template>

<script lang="babel">
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {ValidationProvider} from "vee-validate";
import Dropdown from "@/components/Dropdown";
import PublishBadge from "@/components/PublishBadge";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Tokyo");

const MIN_YEAR = 100
const currentYear = dayjs().year()
const years = []
for(let i = currentYear - MIN_YEAR; i <= currentYear; i++) {
  years.push({
    name: `${i}年`,
    value: i,
  })
}
const months = []
for(let i = 1; i <= 12; i++) {
  months.push({
    name: `${i}月`,
    value: i,
  })
}

export default {
  name: "BirthdayInput",
  components: {
    ValidationProvider,
    PublishBadge
  },
  props: {
    value: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    inputId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      years: years,
      months: months,
      selectedYear: null,
      selectedMonth: null,
      selectedDate: null,
      yearSelectFocused: false,
      monthSelectFocused: false,
      dateSelectFocused: false,
    }
  },
  created() {
    if (this.value) {
      const [
        year,
        month,
        date,
      ] = this.value.split('-')
      this.selectedYear = isNaN(parseInt(year)) ? null : parseInt(year)
      this.selectedMonth = isNaN(parseInt(month)) ? null : parseInt(month)
      this.selectedDate = isNaN(parseInt(date)) ? null : parseInt(date)
    }
  },
  computed: {
    dates() {
      if (!this.selectedYear || !this.selectedMonth) {
        return []
      }
      const lastDay = dayjs(`${this.selectedYear}-${this.selectedMonth}-01`).endOf('month')
      const tmp = []
      for (let i = 1; i <= lastDay.date(); i++) {
        tmp.push({
          name: `${i}日`,
          value: i,
        })
      }
      return tmp
    },
    birthdayStr() {
      return `${this.selectedYear}-${this.selectedMonth}-${this.selectedDate}`
    },
  },
  methods: {
    onYearBlur() {
      this.$emit('blur')
      this.yearSelectFocused = false
    },
    onYearChange() {
      this.selectedDate = null
      this.$emit('change', this.birthdayStr)
    },
    onMonthChange() {
      this.selectedDate = null
      this.$emit('change', this.birthdayStr)
    },
    onDateChange() {
      this.$emit('change', this.birthdayStr)
    },
    onMonthBlur() {
      this.$emit('blur')
      this.monthSelectFocused = false
    },
    onDateBlur() {
      this.$emit('blur')
      this.dateSelectFocused = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  &-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-col {
    flex: 1;
  }
}

.dropdown {
  position: relative;

  &-label {
    color: #CAC9C9;
  }

  &-select {
    select {
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
      border: none;
      letter-spacing: 0.03rem;
      outline: none;
      height: 42px;
      width: 100%;
      -webkit-appearance: none;
      border-radius: 1px;
      appearance: none;
    }
  }
}
.icon-padding {
  padding-right: 44px;
}

.text-field {
  position: relative;
}

.field-label, .input-field > input::placeholder {
  color: #CAC9C9;
}

.input-field > input {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
  border: none;
  letter-spacing: 0.03rem;
  outline: none;
  height: 42px;
  width: 100%;
  -webkit-appearance: none;
  border-radius: 1px;
  appearance: none;
}

.input-field input:focus {
  box-shadow: 0px 2px 0px #F94848;
}

.error {
  box-shadow: 0 2px 0 #f94848 !important;
  background: rgba(241, 72, 72, .1);
}

.error-message {
  padding-top: 7px;
  padding-bottom: 7px;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: .03em;
  color: #f14848;
  height: 40px;
}

.publish-badge {
  font-size: 10px;
  position: absolute;
  right: 5px;
  top: 30%;
  background-color: white;
}
</style>
